import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

import typeStyle from 'styles/typeStyle'

import LockIcon from '../../../components/icons/Lock'

const HintWrapper = styled.div`
  ${typeStyle('-ds-font-body-light')}
  display: flex;
  align-items: center;

  color: ${({ theme }) => theme['-ds-neutral-500'].value};

  svg {
    height: 18px;
    margin-right: 10px;
  }
`

export const VisibilityHint: FC<PropsWithChildren> = ({ children }) => (
  <HintWrapper>
    <LockIcon />
    {/* @ts-ignore -- not typed yet */}
    {children}
  </HintWrapper>
)
